
import { RevDivider } from '@ds/components/Divider'
import { RevLink } from '@ds/components/Link'
import { RevList } from '@ds/components/List'
import { RevModal } from '@ds/components/Modal'
import { IconCheckInCircleFilled } from '@ds/icons/IconCheckInCircleFilled'

import { MODAL_NAMES } from '@config/constants'
import IllustrationPhoneBattery from '@core/illustrations/IllustrationPhoneBattery.svg'
import IllustrationQuestionMark from '@core/illustrations/IllustrationQuestionMark.svg'
import FormattedMessage from '@i18n/components/FormattedMessage'

import ComparisonArea from './ComparisonArea'
import FaqItem from './FaqItem'
import translations from './Modal.translations'

export default {
  components: {
    ComparisonArea,
    FaqItem,
    FormattedMessage,
    IconCheckInCircleFilled,
    IllustrationPhoneBattery,
    IllustrationQuestionMark,
    RevDivider,
    RevModal,
    RevLink,
    RevList,
  },
  props: {
    deviceName: {
      type: String,
      required: true,
    },
  },
  computed: {
    modalName: () => MODAL_NAMES.PRODUCT.NEW_BATTERY,

    translations: () => translations,

    faqItem1() {
      return [
        { paragraph: this.translations.section2Answer1Paragraph1 },
        { paragraph: this.translations.section2Answer1Paragraph2 },
        {
          paragraph: this.translations.section2Answer1Paragraph3,
          link: this.translations.section2Answer1Paragraph3Link,
          linkText: this.translations.section2Answer1Paragraph3LinkText,
        },
      ]
    },

    faqItem2() {
      return [
        { paragraph: this.translations.section2Answer2Paragraph1 },
        { paragraph: this.translations.section2Answer2Paragraph2 },
        { paragraph: this.translations.section2Answer2Paragraph3 },
      ]
    },

    faqItem3() {
      return [
        { paragraph: this.translations.section2Answer3Paragraph1 },
        {
          paragraph: this.translations.section2Answer3Paragraph2,
          link: this.translations.section2Answer3Paragraph2Link,
          linkText: this.translations.section2Answer3Paragraph2LinkText,
        },
        {
          paragraph: this.translations.section2Answer3Paragraph3,
        },
      ]
    },
  },
}
